module.exports = __webpack_public_path__ + "static/media/aauxnext-sm.bca07a9d.woff2";